import React, { useEffect, useRef, useState } from 'react';
import { Container } from '@mui/material';
import useChatbotWeb from './useChatbotWeb';
import ModalEmprestimoUpdateDadosCadastrais from '../../components/modalEmprestimoUpdateDadosCadastrais';
import ModalAddMessage from '../../components/chatbot/ModalAddMessage/ModalAddMessage';
import ModalViewCommunication from '../../components/chatbot/ModalViewCommunication/ModalViewCommunication';
import ModalRegionalSelect from '../../components/modalRegionalSelect';
import ModalPostoEscala from '../../components/chatbot/ModalPostoEscala/ModalPostoEscala';
import ModalDataHoraAusencia from '../../components/chatbot/ModalDataHoraAusencia/ModalDataHoraAusencia';
import {
    Main,
    WhatsAppContainer,
    SessionListPanel,
    SessionListHeader,
    SessionListTitle,
    ChatPanel,
    ChatHeader,
    BackButton,
    ChatAvatar,
    ChatHeaderInfo,
    ChatHeaderName,
    ChatHeaderStatus,
    WelcomeScreen,
    WelcomeIcon,
    WelcomeTitle,
    WelcomeSubtitle,
    SessionItem,
    SessionItemHeader,
    SessionName,
    SessionTime,
    SessionPreview,
    StatusChip,
    SearchContainer,
    SearchInput,
    SessionList,
    ChatMessages,
    EmptyState,
    FilterContainer,
    FilterSelect,
    ActionButton,
    NewChatButton,
    PaginationContainer,
    PaginationButton,
    PaginationInfo,
} from './Styled';
import {
    Box,
    TextField,
    IconButton,
    List,
    ListItem,
    Avatar,
    Typography,
    Input,
    CardMedia,
    Button,
} from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AddCommentIcon from '@mui/icons-material/AddComment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import ChatIcon from '@mui/icons-material/Chat';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Axios from 'axios';

const ChatbotWeb = () => {
    const {
        chatSessions,
        currentPage,
        totalPages,
        myStatusCount,
        generalStatusCount,
        searchQuery,
        setSearchQuery,
        searchStatus,
        setSearchStatus,
        fetchChatSessions,
        selectedSessionId,
        selectedSession,
        messages,
        newMessage,
        setNewMessage,
        showOptions,
        options,
        showInputBar,
        remoteTypingStatus,
        selectSession,
        handleSendMessage,
        handleFileAttach,
        handleSelectOption,
        handleNewChat,
        setSelectedSessionId,
        setSelectedSession,
        sendTypingStatus,
        markMessagesAsRead,
        clearUnreadCount,
        statusList,
        getStatusStyle,
        habilitarNovoChat,
        chatProfile,
        profile,
        goLink,
        tokenChat,
        LogoImgSad,
        // Loan modal
        showLoanModal,
        setShowLoanModal,
        loanData,
        loadingLoanData,
        loadingPage,
        isBotTyping,
        handleLoanFormSubmit,
        // MQTT and real-time functions
        getElapsedTime,
        getStatusLabel,
        // Online status functions
        checkUserOnlineStatus,
        getSessionOnlineStatus,
        // Add Message Modal
        showAddMessageModal,
        setShowAddMessageModal,
        mudarStatusSessao,
        handleLinkCommunication,
        setOptions,
        setShowOptions,
        setShowInputBar,
        setMessages,
        LogoImg,

        // View Communication Modal
        showViewCommunicationModal,
        setShowViewCommunicationModal,
        viewCommunicationId,

        // Date Picker Modal
        showDatePickerModal,
        selectedDate,
        datePickerTitle,
        handleDateSelection,
        closeDatePickerModal,

        // Regional Modal
        showRegionalModal,
        handleRegionalSelection,
        closeRegionalModal,
        fetchRegionalCommunication,

        // Communication data
        comunicacaoInternaData,
        handleComunicacaoInternaFileUpload,

        fetchCommunicationBySession,

        // Posto e Escala Modal
        showPostoEscalaModal,
        closePostoEscalaModal,
        ausenciaData,
        setAusenciaData,

        // Data e Hora Ausencia Modal
        showDataHoraAusenciaModal,
        closeDataHoraAusenciaModal,
        apiCHAT,
    } = useChatbotWeb();

    const messagesEndRef = useRef(null);
    const chatMessagesRef = useRef(null);
    const sessionListRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);
    const typingTimeoutRef = useRef(null);
    const isProgrammaticScrollRef = useRef(false);
    const [isUserScrolledUp, setIsUserScrolledUp] = useState(false);
    const [previousMessagesLength, setPreviousMessagesLength] = useState(0);
    const [tempDateValue, setTempDateValue] = useState('');
    const lastNewChatClickRef = useRef(0);
    const [videoModal, setVideoModal] = useState({ open: false, url: '' });

    // Throttled new chat handler - prevents multiple clicks within 2 seconds
    const handleNewChatThrottled = () => {
        const now = Date.now();
        const timeSinceLastClick = now - lastNewChatClickRef.current;

        if (timeSinceLastClick < 2000) {
            console.log('Por favor, aguarde dois segundos antes de criar outro chat');
            return;
        }

        lastNewChatClickRef.current = now;
        handleNewChat();
    };

    // Conditional file upload handler
    const handleConditionalFileUpload = async () => {
        // Check if we have a selected session
        if (!selectedSessionId) {
            console.log('No session selected');
            return;
        }

        let communicationDataFetch = await fetchCommunicationBySession(selectedSessionId);

        // Check if there's an active communication session
        if (communicationDataFetch && communicationDataFetch.cmit_id_comunicacao_interna) {
            // Use communication-specific file upload
            try {
                await handleComunicacaoInternaFileUpload();
            } catch (error) {
                // Only log if not a user cancellation
                if (error !== 'No file selected or missing required data') {
                    console.error('Error uploading file:', error);
                }
            }
        } else {
            console.log('Usando upload de arquivo padrão');
            // Create a synthetic file input for default file attach
            const input = document.createElement('input');
            input.type = 'file';
            input.onchange = (e) => handleFileAttach(e);
            input.click();
        }
    };

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Enable smooth scrolling for mobile devices
        const enableMobileScrolling = () => {
            if (window.innerWidth <= 768) {
                // Add touch-action CSS to body for better mobile scrolling
                document.body.style.touchAction = 'manipulation';

                // Ensure scrollable areas work properly on mobile
                const scrollableElements = document.querySelectorAll('[data-scrollable]');
                scrollableElements.forEach((element) => {
                    element.style.webkitOverflowScrolling = 'touch';
                    element.style.overscrollBehavior = 'contain';
                });
            }
        };

        checkMobile();
        enableMobileScrolling();
        window.addEventListener('resize', checkMobile);
        window.addEventListener('resize', enableMobileScrolling);

        return () => {
            window.removeEventListener('resize', checkMobile);
            window.removeEventListener('resize', enableMobileScrolling);
            // Clear typing timeout on unmount
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, []);

    // Auto-scroll when messages are sent or received
    useEffect(() => {
        const isNewMessage = messages.length > previousMessagesLength;

        // Update message length tracker
        setPreviousMessagesLength(messages.length);

        // Only auto-scroll for new messages if user is near the bottom (not scrolled up)
        if ((isNewMessage || showOptions || loadingPage) && messages.length > 0 && !isUserScrolledUp) {
            const timer = setTimeout(() => {
                scrollToBottom();
            }, 200); // Increased delay to prevent conflicts
            return () => clearTimeout(timer);
        }
    }, [messages.length, showOptions, loadingPage, isUserScrolledUp]); // Simplified dependencies // Initial scroll when session is first loaded
    useEffect(() => {
        if (selectedSessionId && messages.length > 0) {
            // Always scroll to bottom when opening a new session
            setIsUserScrolledUp(false);
            const timer = setTimeout(() => {
                scrollToBottom();
            }, 150);

            return () => clearTimeout(timer);
        }
    }, [selectedSessionId]);

    // Scroll when date picker modal closes
    useEffect(() => {
        if (!showDatePickerModal && messages.length > 0) {
            const timer = setTimeout(() => {
                scrollToBottom();
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [showDatePickerModal, messages.length]);

    // Mobile touch scroll fix
    useEffect(() => {
        if (isMobile) {
            const enableTouchScrolling = (element) => {
                if (element) {
                    // Enable momentum scrolling for iOS
                    element.style.webkitOverflowScrolling = 'touch';
                    element.style.overscrollBehavior = 'contain';

                    // Prevent scroll chaining and ensure proper touch handling
                    const handleTouchStart = (e) => {
                        // Allow scrolling
                        if (element.scrollHeight <= element.clientHeight) {
                            return;
                        }
                    };

                    const handleTouchMove = (e) => {
                        // Enable touch scrolling by not preventing default
                        if (element.scrollHeight <= element.clientHeight) {
                            e.preventDefault();
                        }
                    };

                    element.addEventListener('touchstart', handleTouchStart, { passive: true });
                    element.addEventListener('touchmove', handleTouchMove, { passive: false });

                    return () => {
                        element.removeEventListener('touchstart', handleTouchStart);
                        element.removeEventListener('touchmove', handleTouchMove);
                    };
                }
            };

            const chatCleanup = enableTouchScrolling(chatMessagesRef.current);
            const sessionCleanup = enableTouchScrolling(sessionListRef.current);

            return () => {
                if (chatCleanup) chatCleanup();
                if (sessionCleanup) sessionCleanup();
            };
        }
    }, [isMobile]);

    // Track user scroll position to determine if they've scrolled up
    useEffect(() => {
        const chatContainer = chatMessagesRef.current;
        if (!chatContainer) return;

        let scrollTimeout;

        const handleScroll = () => {
            // Ignore programmatic scrolls to prevent oscillation
            if (isProgrammaticScrollRef.current) {
                return;
            }

            // Debounce scroll events to prevent oscillation
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const { scrollTop, scrollHeight, clientHeight } = chatContainer;
                const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100; // 100px threshold for better UX

                setIsUserScrolledUp(!isAtBottom);
            }, 150); // 150ms debounce
        };

        chatContainer.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            chatContainer.removeEventListener('scroll', handleScroll);
            clearTimeout(scrollTimeout);
        };
    }, [selectedSessionId]);

    useEffect(() => {
        if (selectedSession) {
            console.log('Sessao:', selectedSession);
            // Reset scroll state when opening a new session
            setIsUserScrolledUp(false);
        }
    }, [selectedSession]);

    // Session change is handled by the initial scroll effect above

    const scrollToBottom = () => {
        if (messagesEndRef.current && chatMessagesRef.current) {
            // Mark as programmatic scroll to prevent oscillation
            isProgrammaticScrollRef.current = true;

            try {
                // For immediate scrolling, use direct method first
                chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;

                // Then apply smooth scroll for visual effect
                setTimeout(() => {
                    if (messagesEndRef.current) {
                        messagesEndRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'end',
                            inline: 'nearest',
                        });
                    }
                    // Reset scroll state and allow scroll detection again
                    setIsUserScrolledUp(false);
                    setTimeout(() => {
                        isProgrammaticScrollRef.current = false;
                    }, 200); // Allow time for scroll animation to complete
                }, 50);
            } catch (error) {
                // Fallback method: Direct scroll only
                if (chatMessagesRef.current) {
                    chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
                    setIsUserScrolledUp(false);
                    isProgrammaticScrollRef.current = false;
                }
            }
        }
    };
    const isZipdinSignUrl = (url) => {
        return /https?:\/\/[^/]*zipdin\.com\.br\/sign\/[a-zA-Z0-9]+/.test(url);
    };

    const EAD_VIDEO_PREFIX = 'https://br-se1.magaluobjects.com/arquivos-compliance/complice/ead/';

    const parseStringWithLink = (text, messageDate) => {
        if (!text || typeof text !== 'string') {
            return text || '';
        }

        // Regex to detect bare Zipdin sign URLs in text
        const zipdinRegex = /https?:\/\/[^\s]*zipdin\.com\.br\/sign\/[a-zA-Z0-9]+/g;
        // Regex to detect bare EAD video URLs in text
        const eadVideoRegex = new RegExp(
            'https://br-se1\\.magaluobjects\\.com/arquivos-compliance/complice/ead/[^\\s]+',
            'g',
        );

        const isExternalLink = (url) => {
            return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www.');
        };

        const handleDownload = async (url) => {
            try {
                const response = await Axios.get(url, {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${tokenChat}`,
                    },
                });
                const blob = new Blob([response.data]);
                const blobUrl = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = 'arquivo-download.pdf';
                a.click();

                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Erro ao baixar o arquivo:', error);
            }
        };

        const handleExternalLink = (url) => {
            const finalUrl = url.startsWith('www.') ? `https://${url}` : url;
            window.open(finalUrl, '_blank', 'noopener,noreferrer');
        };

        // Step 1: Split text by special URL types (Zipdin and EAD video)
        // Build a combined list of segments in order of appearance
        const allMatches = [];

        let m;
        zipdinRegex.lastIndex = 0;
        while ((m = zipdinRegex.exec(text)) !== null) {
            allMatches.push({ type: 'zipdin', value: m[0], index: m.index, end: zipdinRegex.lastIndex });
        }

        eadVideoRegex.lastIndex = 0;
        while ((m = eadVideoRegex.exec(text)) !== null) {
            allMatches.push({ type: 'ead', value: m[0], index: m.index, end: eadVideoRegex.lastIndex });
        }

        allMatches.sort((a, b) => a.index - b.index);

        const specialParts = [];
        let lastSpecialIndex = 0;

        for (const match of allMatches) {
            if (match.index > lastSpecialIndex) {
                specialParts.push({ type: 'text', value: text.slice(lastSpecialIndex, match.index) });
            }
            specialParts.push({ type: match.type, value: match.value });
            lastSpecialIndex = match.end;
        }

        if (lastSpecialIndex < text.length) {
            specialParts.push({ type: 'text', value: text.slice(lastSpecialIndex) });
        }

        // Step 2: For each segment, render the appropriate element
        const markdownRegex = /\[(.*?)\]\((.*?)\)/g;
        const finalParts = [];

        specialParts.forEach((part, partIdx) => {
            if (part.type === 'zipdin') {
                const url = part.value;
                finalParts.push(
                    <a
                        key={`zipdin-${partIdx}-${url}`}
                        href={url}
                        onClick={(e) => {
                            e.preventDefault();
                            window.open(url, '_blank', 'noopener,noreferrer');
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            marginTop: '8px',
                            padding: '8px 16px',
                            backgroundColor: '#1565c0',
                            color: '#ffffff',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            boxShadow: '0 2px 6px rgba(21,101,192,0.4)',
                            transition: 'background-color 0.2s, box-shadow 0.2s',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#0d47a1';
                            e.currentTarget.style.boxShadow = '0 4px 10px rgba(21,101,192,0.6)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#1565c0';
                            e.currentTarget.style.boxShadow = '0 2px 6px rgba(21,101,192,0.4)';
                        }}
                    >
                        ✍️ Assinar Documento
                    </a>,
                );
            } else if (part.type === 'ead') {
                const url = part.value;
                let isExpired = false;
                if (messageDate) {
                    const msgTime = new Date(messageDate).getTime();
                    const now = new Date().getTime();
                    if (now - msgTime > 3600000) {
                        isExpired = true;
                    }
                }
                finalParts.push(
                    <button
                        key={`ead-${partIdx}-${url}`}
                        onClick={() => !isExpired && setVideoModal({ open: true, url })}
                        disabled={isExpired}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginTop: '8px',
                            padding: '8px 16px',
                            backgroundColor: isExpired ? '#9e9e9e' : '#c62828',
                            color: '#ffffff',
                            borderRadius: '8px',
                            border: 'none',
                            fontWeight: 'bold',
                            fontSize: '0.875rem',
                            cursor: isExpired ? 'not-allowed' : 'pointer',
                            boxShadow: isExpired ? 'none' : '0 2px 6px rgba(198,40,40,0.4)',
                            transition: 'background-color 0.2s, box-shadow 0.2s',
                        }}
                        onMouseEnter={(e) => {
                            if (!isExpired) {
                                e.currentTarget.style.backgroundColor = '#b71c1c';
                                e.currentTarget.style.boxShadow = '0 4px 10px rgba(198,40,40,0.6)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!isExpired) {
                                e.currentTarget.style.backgroundColor = '#c62828';
                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(198,40,40,0.4)';
                            }
                        }}
                    >
                        {isExpired ? 'Link expirado! Se precisar, peça novamente.' : '▶ Assistir Vídeo Aula'}
                    </button>,
                );
            } else {
                // Apply markdown link parsing to plain text segments
                const segmentText = part.value;
                markdownRegex.lastIndex = 0;
                let lastIndex = 0;
                let match;

                while ((match = markdownRegex.exec(segmentText)) !== null) {
                    if (match.index > lastIndex) {
                        finalParts.push(segmentText.slice(lastIndex, match.index));
                    }

                    const url = match[2];
                    const linkText = match[1];

                    // If the markdown link URL is an EAD video, render a video button
                    if (url.startsWith(EAD_VIDEO_PREFIX)) {
                        let isExpired = false;
                        if (messageDate) {
                            const msgTime = new Date(messageDate).getTime();
                            const now = new Date().getTime();
                            if (now - msgTime > 3600000) {
                                isExpired = true;
                            }
                        }
                        finalParts.push(
                            <button
                                key={`ead-md-${partIdx}-${match.index}`}
                                onClick={() => !isExpired && setVideoModal({ open: true, url })}
                                disabled={isExpired}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginTop: '8px',
                                    padding: '8px 16px',
                                    backgroundColor: isExpired ? '#9e9e9e' : '#c62828',
                                    color: '#ffffff',
                                    borderRadius: '8px',
                                    border: 'none',
                                    fontWeight: 'bold',
                                    fontSize: '0.875rem',
                                    cursor: isExpired ? 'not-allowed' : 'pointer',
                                    boxShadow: isExpired ? 'none' : '0 2px 6px rgba(198,40,40,0.4)',
                                    transition: 'background-color 0.2s, box-shadow 0.2s',
                                }}
                                onMouseEnter={(e) => {
                                    if (!isExpired) {
                                        e.currentTarget.style.backgroundColor = '#b71c1c';
                                        e.currentTarget.style.boxShadow = '0 4px 10px rgba(198,40,40,0.6)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isExpired) {
                                        e.currentTarget.style.backgroundColor = '#c62828';
                                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(198,40,40,0.4)';
                                    }
                                }}
                            >
                                {isExpired
                                    ? 'Link expirado! Se precisar, peça novamente.'
                                    : `▶ ${linkText || 'Assistir Vídeo Aula'}`}
                            </button>,
                        );
                    } else {
                        let linkHref = '#';
                        if (isExternalLink(url)) {
                            linkHref = url.startsWith('www.') ? `https://${url}` : url;
                        }

                        finalParts.push(
                            <a
                                key={`md-${partIdx}-${match.index}-${url}`}
                                href={linkHref}
                                onClick={(e) => {
                                    if (isExternalLink(url)) {
                                        e.preventDefault();
                                        handleExternalLink(url);
                                    } else {
                                        e.preventDefault();
                                        handleDownload(url);
                                    }
                                }}
                                target={isExternalLink(url) ? '_blank' : undefined}
                                rel={isExternalLink(url) ? 'noopener noreferrer' : undefined}
                                style={{
                                    color: '#0056b3',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                            >
                                {linkText}
                            </a>,
                        );
                    }

                    lastIndex = markdownRegex.lastIndex;
                }

                if (lastIndex < segmentText.length) {
                    finalParts.push(segmentText.slice(lastIndex));
                }
            }
        });

        return finalParts;
    };

    const parseStringWithLinkToImage = (url, ext) => {
        if (!url) return null;

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
        const isImage = imageExtensions.includes(ext?.toLowerCase());

        if (isImage) {
            return (
                <CardMedia
                    component="img"
                    image={url}
                    alt={`Imagem ${ext}`}
                    sx={{
                        borderRadius: 2,
                        maxWidth: '100%',
                        maxHeight: 200,
                        objectFit: 'contain',
                        cursor: 'pointer',
                        mt: 1,
                    }}
                    onClick={() => window.open(url, '_blank')}
                />
            );
        } else {
            const isPDF = ext?.toLowerCase() === 'pdf';

            const handleFileAction = async (fileUrl) => {
                if (isPDF) {
                    window.open(fileUrl, '_blank');
                } else {
                    try {
                        const response = await Axios.get(fileUrl, {
                            responseType: 'blob',
                            headers: {
                                Authorization: `Bearer ${tokenChat}`,
                            },
                        });
                        const blob = new Blob([response.data]);
                        const blobUrl = window.URL.createObjectURL(blob);

                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = `arquivo.${ext || 'bin'}`;
                        a.click();

                        window.URL.revokeObjectURL(blobUrl);
                    } catch (error) {
                        console.error('Erro ao baixar o arquivo:', error);
                    }
                }
            };

            return (
                <Box sx={{ mt: 1 }}>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleFileAction(url);
                        }}
                        style={{
                            color: '#0056b3',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        {isPDF ? '📄' : '📎'}{' '}
                        {isPDF ? 'Visualizar PDF' : `Baixar arquivo ${ext ? `.${ext.toUpperCase()}` : ''}`}
                    </a>
                </Box>
            );
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const nomeUsuario = `${profile?.pess_nome}-${profile.pess_id_pessoa}`;

    // Debounced typing handler
    const handleTyping = (isTyping) => {
        // Clear any existing timeout
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        if (isTyping) {
            // Send typing started
            sendTypingStatus(true);
            // Set timeout to stop typing after 2 seconds of inactivity
            typingTimeoutRef.current = setTimeout(() => {
                sendTypingStatus(false);
            }, 2000);
        } else {
            // Immediately stop typing
            sendTypingStatus(false);
        }
    };

    // Fix mobile scroll issues
    const fixMobileScrolling = () => {
        if (isMobile) {
            // Add a small delay to ensure DOM is ready
            setTimeout(() => {
                const chatElement = chatMessagesRef.current;
                const sessionElement = sessionListRef.current;

                [chatElement, sessionElement].forEach((element) => {
                    if (element) {
                        // Force recalculation of scroll properties
                        element.style.transform = 'translateZ(0)';
                        element.style.webkitTransform = 'translateZ(0)';

                        // Trigger reflow
                        element.scrollTop = element.scrollTop;
                    }
                });
            }, 100);
        }
    };

    // Call fixMobileScrolling when messages change
    useEffect(() => {
        fixMobileScrolling();
    }, [messages, isMobile]);

    // Mobile scrolling is now handled by the smart scroll system above

    // Add CSS for real-time updates and last message styling
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .session-item-updated {
                background-color: #e3f2fd !important;
                transition: background-color 0.3s ease;
                animation: sessionUpdatePulse 1s ease-in-out;
            }

            @keyframes sessionUpdatePulse {
                0% { transform: scale(1); }
                50% { transform: scale(1.02); background-color: #e3f2fd; }
                100% { transform: scale(1); }
            }

            .session-last-message {
                font-style: italic;
                color: #666 !important;
                font-size: 0.875rem !important;
                margin-top: 4px !important;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                animation: fadeIn 0.3s ease-in-out;
            }

            @keyframes fadeIn {
                from { opacity: 0; transform: scale(0.9); }
                to { opacity: 1; transform: scale(1); }
            }

            .session-time-updated {
                color: #4CAF50 !important;
                font-weight: bold !important;
                animation: timeUpdate 0.5s ease-in-out;
            }

            @keyframes timeUpdate {
                0% { color: #4CAF50; transform: scale(1.1); }
                100% { color: inherit; transform: scale(1); }
            }

            @keyframes unreadPulse {
                0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
                50% { transform: scale(1.1); box-shadow: 0 0 0 4px rgba(37, 211, 102, 0); }
                100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    // Auto-mark messages as read when user interacts with the chat
    useEffect(() => {
        const handleChatInteraction = () => {
            if (selectedSessionId && markMessagesAsRead) {
                markMessagesAsRead(selectedSessionId);
            }
        };

        // Add event listeners to chat panel for user interaction
        if (selectedSessionId && chatMessagesRef.current) {
            const chatPanel = chatMessagesRef.current;

            // Mark messages as read on various interactions
            chatPanel.addEventListener('click', handleChatInteraction);
            chatPanel.addEventListener('focus', handleChatInteraction, true);
            chatPanel.addEventListener('scroll', handleChatInteraction);

            return () => {
                chatPanel.removeEventListener('click', handleChatInteraction);
                chatPanel.removeEventListener('focus', handleChatInteraction, true);
                chatPanel.removeEventListener('scroll', handleChatInteraction);
            };
        }
    }, [selectedSessionId, markMessagesAsRead]);

    // Periodic auto-mark messages as read while chat is active and visible
    useEffect(() => {
        if (!selectedSessionId || !markMessagesAsRead) return;

        let intervalId;

        // Only run if page is visible and session is selected
        const startPeriodicReadMarkig = () => {
            if (!document.hidden && selectedSessionId) {
                intervalId = setInterval(() => {
                    if (!document.hidden && selectedSessionId) {
                        markMessagesAsRead(selectedSessionId);
                    }
                }, 3000); // Check every 3 seconds
            }
        };

        // Handle visibility changes
        const handleVisibilityChange = () => {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }

            if (!document.hidden) {
                // Mark messages as read immediately when page becomes visible
                markMessagesAsRead(selectedSessionId);
                startPeriodicReadMarkig();
            }
        };

        // Start immediately if page is visible
        if (!document.hidden) {
            startPeriodicReadMarkig();
        }

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [selectedSessionId, markMessagesAsRead]);

    return (
        <Main>
            <Container maxWidth={false} style={{ height: '100%', padding: '20px' }}>
                <WhatsAppContainer>
                    {/* Session List Panel */}
                    <SessionListPanel selectedSession={selectedSession && isMobile}>
                        <SessionListHeader>
                            <SessionListTitle>Minhas Sessões</SessionListTitle>
                            <Box display="flex" gap={1}>
                                {chatProfile &&
                                    chatProfile.nivel_acesso !== null &&
                                    Object.keys(chatProfile).length > 0 && (
                                        <ActionButton
                                            onClick={() => goLink('/chat/profiles')}
                                            title="Gerenciar Administradores"
                                        >
                                            <ManageAccountsIcon />
                                        </ActionButton>
                                    )}
                                {habilitarNovoChat() && (
                                    <ActionButton onClick={handleNewChatThrottled} title="Criar um novo Chat">
                                        <AddCommentIcon />
                                    </ActionButton>
                                )}
                            </Box>
                        </SessionListHeader>

                        <SearchContainer>
                            <SearchInput
                                placeholder="Buscar por Chamado, data ou status..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </SearchContainer>

                        <FilterContainer>
                            <FilterSelect value={searchStatus || ''} onChange={(e) => setSearchStatus(e.target.value)}>
                                {statusList.map(
                                    (status) =>
                                        (generalStatusCount[status.key] || status.key === '') && (
                                            <option key={status.key} value={status.key}>
                                                {status.label}
                                            </option>
                                        ),
                                )}
                            </FilterSelect>
                        </FilterContainer>

                        <SessionList data-scrollable ref={sessionListRef}>
                            {chatSessions.map((sessao) => {
                                const statusInfo = getStatusStyle(sessao.status);
                                const isSelected = selectedSessionId === sessao.id;

                                // Handle last message display
                                let lastMessageDisplay = '';
                                let timeDisplay = '00:00';

                                if (sessao.last_message && sessao.last_message.mensagem_usuario) {
                                    // Show user's last message
                                    const messageText = sessao.last_message.mensagem_usuario;
                                    // Truncate message if too long
                                    lastMessageDisplay =
                                        messageText.length > 50 ? messageText.substring(0, 50) + '...' : messageText;

                                    // Format date and time in Brazilian format
                                    if (sessao.last_message.data_mensagem) {
                                        timeDisplay = new Date(sessao.last_message.data_mensagem).toLocaleString(
                                            'pt-BR',
                                            {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                            },
                                        );
                                    }
                                } else {
                                    // Fallback to session creation time
                                    timeDisplay = new Date(sessao.data_criacao).toLocaleString('pt-BR', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    });
                                }

                                // Get unread message count
                                const unreadCount = sessao.last_message?.contar_nao_lida || 0;

                                return (
                                    <SessionItem
                                        key={sessao.id}
                                        selected={isSelected}
                                        onClick={() => selectSession(sessao)}
                                        data-session-id={sessao.id}
                                        data-timestamp={sessao.last_message?.data_mensagem || sessao.data_criacao}
                                    >
                                        <SessionItemHeader>
                                            <SessionName>
                                                Chamado: {sessao.id} - {sessao.usuario.nome}
                                            </SessionName>
                                            <SessionTime className="session-time-display">{timeDisplay}</SessionTime>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                {/* Unread message count badge */}
                                                {unreadCount > 0 && (
                                                    <Box
                                                        sx={{
                                                            backgroundColor: '#25d366',
                                                            color: '#ffffff',
                                                            borderRadius: '50%',
                                                            minWidth: '20px',
                                                            height: '20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '0.75rem',
                                                            fontWeight: 'bold',
                                                            animation: 'unreadPulse 2s infinite',
                                                            '@keyframes unreadPulse': {
                                                                '0%': { transform: 'scale(1)' },
                                                                '50%': { transform: 'scale(1.1)' },
                                                                '100%': { transform: 'scale(1)' },
                                                            },
                                                        }}
                                                        title={`${unreadCount} mensagem${
                                                            unreadCount > 1 ? 's' : ''
                                                        } não lida${unreadCount > 1 ? 's' : ''}`}
                                                    >
                                                        {unreadCount > 99 ? '99+' : unreadCount}
                                                    </Box>
                                                )}
                                            </Box>
                                        </SessionItemHeader>

                                        {/* Show last message if available */}
                                        {lastMessageDisplay ? (
                                            <SessionPreview className="session-last-message">
                                                {lastMessageDisplay}
                                            </SessionPreview>
                                        ) : null}

                                        <SessionPreview>
                                            Empresa: {sessao.usuario.clie_nome_fantasia || sessao.usuario.clie_nome}
                                        </SessionPreview>
                                        <StatusChip color={statusInfo.color} textColor={statusInfo.textColor}>
                                            {statusInfo.label}
                                        </StatusChip>
                                    </SessionItem>
                                );
                            })}
                            {chatSessions.length === 0 && <EmptyState>Nenhuma sessão encontrada.</EmptyState>}
                        </SessionList>

                        {totalPages > 1 && (
                            <PaginationContainer>
                                <PaginationButton
                                    disabled={currentPage === 1}
                                    onClick={() => fetchChatSessions(currentPage - 1)}
                                >
                                    Anterior
                                </PaginationButton>
                                <PaginationInfo>
                                    Página: {currentPage} de {totalPages}
                                </PaginationInfo>
                                <PaginationButton
                                    disabled={currentPage === totalPages}
                                    onClick={() => fetchChatSessions(currentPage + 1)}
                                >
                                    Próxima
                                </PaginationButton>
                            </PaginationContainer>
                        )}
                    </SessionListPanel>

                    {/* Chat Panel */}
                    <ChatPanel selectedSession={selectedSession}>
                        {selectedSession ? (
                            <>
                                <ChatHeader>
                                    {isMobile && (
                                        <BackButton
                                            selectedSession={selectedSession}
                                            onClick={() => {
                                                setSelectedSessionId(null);
                                                setSelectedSession(null);
                                            }}
                                        >
                                            <ArrowBackIcon />
                                        </BackButton>
                                    )}
                                    <ChatAvatar>
                                        {selectedSession.usuario.nome
                                            ? selectedSession.usuario.nome[0].toUpperCase()
                                            : 'U'}
                                    </ChatAvatar>
                                    <ChatHeaderInfo>
                                        <ChatHeaderName>
                                            Chamado: {selectedSession.id} - {selectedSession.usuario.nome}
                                            {(() => {
                                                if (selectedSession.usuario.id != profile.pess_id_pessoa) {
                                                    const onlineStatus = getSessionOnlineStatus(selectedSession);

                                                    return onlineStatus.usuario ? (
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                ml: 1,
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                color: '#4CAF50',
                                                                fontSize: '0.875rem',
                                                                fontWeight: 'normal',
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 8,
                                                                    height: 8,
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#4CAF50',
                                                                    mr: 0.5,
                                                                    animation: 'pulse 2s infinite',
                                                                    '@keyframes pulse': {
                                                                        '0%': { opacity: 1 },
                                                                        '50%': { opacity: 0.5 },
                                                                        '100%': { opacity: 1 },
                                                                    },
                                                                }}
                                                            />
                                                            online
                                                        </Box>
                                                    ) : null;
                                                }
                                            })()}
                                        </ChatHeaderName>

                                        {selectedSession.responsavel?.usuario?.pess_id_pessoa &&
                                            selectedSession.responsavel?.usuario?.pess_id_pessoa !==
                                                profile.pess_id_pessoa && (
                                                <ChatHeaderName
                                                    style={{
                                                        fontSize: '1.0rem',
                                                        fontWeight: 'normal',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {`Atendente: (${selectedSession.responsavel.usuario?.pess_nome}) `}
                                                    {(() => {
                                                        const onlineStatus = getSessionOnlineStatus(selectedSession);
                                                        return onlineStatus.responsavel ? (
                                                            <Box
                                                                component="span"
                                                                sx={{
                                                                    ml: 1,
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    color: '#4CAF50',
                                                                    fontSize: '0.875rem',
                                                                    fontWeight: 'normal',
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: '#4CAF50',
                                                                        mr: 0.5,
                                                                        animation: 'pulse 2s infinite',
                                                                        '@keyframes pulse': {
                                                                            '0%': { opacity: 1 },
                                                                            '50%': { opacity: 0.5 },
                                                                            '100%': { opacity: 1 },
                                                                        },
                                                                    }}
                                                                />
                                                                online
                                                            </Box>
                                                        ) : null;
                                                    })()}
                                                </ChatHeaderName>
                                            )}

                                        <ChatHeaderStatus>
                                            {selectedSession.usuario.clie_nome_fantasia ||
                                                selectedSession.usuario.clie_nome}
                                        </ChatHeaderStatus>
                                    </ChatHeaderInfo>
                                </ChatHeader>

                                <ChatMessages data-scrollable ref={chatMessagesRef}>
                                    <List>
                                        {messages
                                            .filter((msg) => msg && (msg.texto || msg.remetente)) // Filter out invalid messages
                                            .map((msg, index) => {
                                                const isUser = msg.remetente === nomeUsuario;

                                                return (
                                                    <ListItem
                                                        key={index}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: isUser ? 'flex-end' : 'flex-start',
                                                            alignItems: 'flex-start',
                                                            mb: 1,
                                                            px: 0,
                                                        }}
                                                    >
                                                        {msg.remetente !== nomeUsuario && msg.remetente !== 'ISA' && (
                                                            <Avatar
                                                                sx={{
                                                                    bgcolor: '#395e95',
                                                                    className: 'w-90 h-90 rounded-full object-cover',
                                                                    src: LogoImg,
                                                                    width: 40, // Smaller avatar
                                                                    height: 40, // Smaller avatar
                                                                }}
                                                            >
                                                                <Avatar
                                                                    sx={{ bgcolor: '#395e95', width: 40, height: 40 }}
                                                                >
                                                                    {msg.avatar}
                                                                </Avatar>
                                                            </Avatar>
                                                        )}
                                                        {msg.remetente === 'ISA' && (
                                                            <Avatar
                                                                sx={{
                                                                    bgcolor: '#395e95',
                                                                    className: 'w-90 h-90 rounded-full object-cover',
                                                                    src: LogoImg,
                                                                    width: 40, // Smaller avatar
                                                                    height: 40, // Smaller avatar
                                                                }}
                                                            >
                                                                <img
                                                                    src={LogoImg}
                                                                    alt="Altum Bot"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                        objectPosition: 'center top', // aqui você manipula o enquadramento
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            </Avatar>
                                                        )}

                                                        <Box
                                                            sx={{
                                                                maxWidth: '70%',
                                                                borderRadius: '8px',
                                                                px: 2,
                                                                py: 1,
                                                                bgcolor: isUser
                                                                    ? '#0a2b6a'
                                                                    : msg.remetente === 'ISA'
                                                                      ? '#3c3e3eeb'
                                                                      : '#ffffff',
                                                                color: isUser
                                                                    ? '#ffffff'
                                                                    : msg.remetente === 'ISA'
                                                                      ? '#ffffff'
                                                                      : '#111b21',
                                                                textAlign: isUser ? 'right' : 'left',
                                                                boxShadow: '0 1px 0.5px rgba(11,20,26,.13)',
                                                                wordBreak: 'break-word',
                                                                position: 'relative',
                                                                '&::before': {
                                                                    content: '""',
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    [isUser ? 'right' : 'left']: -8,
                                                                    width: 0,
                                                                    height: 0,
                                                                    borderLeft: isUser ? '8px solid d7edf7ff' : 'none',
                                                                    borderRight: !isUser ? '8px solid #ffffff' : 'none',
                                                                    borderTop: '8px solid transparent',
                                                                },
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                fontWeight="bold"
                                                                sx={{ mb: 0.5 }}
                                                            >
                                                                {isUser ? 'Você' : msg.remetente}
                                                            </Typography>
                                                            {msg.image ? (
                                                                <CardMedia
                                                                    component="img"
                                                                    image={msg.image}
                                                                    alt={msg.fileName || 'Imagem anexada'}
                                                                    sx={{
                                                                        borderRadius: 1,
                                                                        maxWidth: '100%',
                                                                        maxHeight: 150,
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Typography
                                                                    variant="body2"
                                                                    component="div"
                                                                    sx={{ whiteSpace: 'pre-wrap' }}
                                                                >
                                                                    {msg.is_file === 1
                                                                        ? parseStringWithLinkToImage(msg.url, msg.ext)
                                                                        : parseStringWithLink(
                                                                              msg.texto || '',
                                                                              msg.data_mensagem,
                                                                          )}
                                                                </Typography>
                                                            )}

                                                            {/* Message timestamp and read status */}

                                                            <Box
                                                                sx={{
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-end',
                                                                    alignItems: 'center',
                                                                    mt: 1,
                                                                    gap: 0.5,
                                                                }}
                                                            >
                                                                {msg.data_mensagem && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            fontSize: '0.75rem',
                                                                            color: isUser ? '#ffffff99' : '#667781',
                                                                        }}
                                                                    >
                                                                        {new Date(msg.data_mensagem).toLocaleTimeString(
                                                                            'pt-BR',
                                                                            {
                                                                                hour: '2-digit',
                                                                                minute: '2-digit',
                                                                            },
                                                                        )}
                                                                    </Typography>
                                                                )}

                                                                {/* Read status indicators - only for non-ISA messages */}
                                                                {msg.remetente !== 'ISA' && (
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            ml: 0.5,
                                                                        }}
                                                                    >
                                                                        {isUser ? (
                                                                            // My message - show double tick based on read status
                                                                            <Box
                                                                                sx={{
                                                                                    fontSize: '14px',
                                                                                    color: msg.mensagem_lida?.lido
                                                                                        ? '#4fc3f7'
                                                                                        : '#ffffff99',
                                                                                    lineHeight: 1,
                                                                                    fontWeight: 'bold',
                                                                                }}
                                                                            >
                                                                                {msg.mensagem_lida?.lido ? '✓✓' : '✓'}
                                                                            </Box>
                                                                        ) : (
                                                                            // Other user's message - show "lido" if read by current user
                                                                            msg.mensagem_lida?.lido && (
                                                                                <Box
                                                                                    sx={{
                                                                                        fontSize: '12px',
                                                                                        color: '#4fc3f7',
                                                                                        lineHeight: 1,
                                                                                        fontStyle: 'italic',
                                                                                        opacity: 0.8,
                                                                                    }}
                                                                                ></Box>
                                                                            )
                                                                        )}
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    </ListItem>
                                                );
                                            })}
                                    </List>

                                    {(isBotTyping || loadingPage) && (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'flex-end',
                                                mb: 1,
                                                ml: 0,
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: '#395e95',
                                                    width: 40,
                                                    height: 40,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <img
                                                    src={LogoImg}
                                                    alt="Altum Bot"
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        objectPosition: 'center top',
                                                        borderRadius: '50%',
                                                    }}
                                                />
                                            </Avatar>
                                            <Box
                                                sx={{
                                                    borderRadius: '18px 18px 18px 4px',
                                                    px: 2,
                                                    py: 1.5,
                                                    bgcolor: '#3c3e3eeb',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    ml: 1,
                                                    minWidth: '60px',
                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
                                                }}
                                            >
                                                <style>{`
                                                    @keyframes botTypingBounce {
                                                        0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
                                                        30% { transform: translateY(-6px); opacity: 1; }
                                                    }
                                                `}</style>
                                                {[0, 1, 2].map((i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            width: 8,
                                                            height: 8,
                                                            borderRadius: '50%',
                                                            backgroundColor: '#ffffff',
                                                            animation: 'botTypingBounce 1.2s ease-in-out infinite',
                                                            animationDelay: `${i * 0.2}s`,
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </Box>
                                    )}

                                    {remoteTypingStatus && (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                                ml: '48px',
                                                mb: 1,
                                                color: 'text.secondary',
                                                fontSize: '0.875rem',
                                            }}
                                        >
                                            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                                                Digitando mensagem...
                                            </Typography>
                                        </Box>
                                    )}

                                    {showOptions && (
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                // flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                alignItems: 'flex-start',
                                                gap: 1,
                                                mt: 1,
                                                ml: '48px',
                                                maxWidth: 'calc(70% - 48px)',
                                                bgcolor: '#ffffff',
                                                boxShadow: '0 1px 0.5px rgba(11,20,26,.13)',
                                                borderRadius: '8px',
                                                px: 1.5,
                                                py: 0.8,
                                            }}
                                        >
                                            {/*

                                            {options.map((opt) => (
                                                <Typography
                                                    key={opt.key}
                                                    component="span"
                                                    onClick={() => handleSelectOption(opt.key, opt.label)}
                                                    sx={{
                                                        color: '#050408',
                                                        cursor: 'pointer',
                                                        textTransform: 'none',
                                                        fontSize: '0.875rem',
                                                        padding: '6px 9px',
                                                        '&:hover': {
                                                            textDecoration: 'underline',
                                                            color: '#0056b3',
                                                        },
                                                    }}
                                                >
                                                    {opt.label}
                                                </Typography>
                                            ))}

                                            */}

                                            {options?.map((opt) => (
                                                <Button
                                                    key={opt.key}
                                                    variant="outlined"
                                                    onClick={() => handleSelectOption(opt.key, opt.label)}
                                                    sx={{
                                                        color: '#050408',
                                                        backgroundColor: '#ffffff',
                                                        borderColor: '#0056b3',
                                                        borderWidth: '2px',
                                                        textTransform: 'none',
                                                        fontSize: '0.875rem',
                                                        padding: '6px 16px',
                                                        borderRadius: '5px',

                                                        '&:hover': {
                                                            backgroundColor: '#f5f5f5',
                                                            borderColor: '#0056b3',
                                                            borderWidth: '2px',
                                                            color: '#0056b3',
                                                        },
                                                    }}
                                                >
                                                    {opt.label}
                                                </Button>
                                            ))}
                                        </Box>
                                    )}

                                    {/* Scroll anchor element - always at the bottom */}
                                    <div
                                        ref={messagesEndRef}
                                        style={{
                                            height: '1px',
                                            visibility: 'hidden',
                                        }}
                                    />
                                </ChatMessages>

                                {/* Scroll to bottom button - appears when user scrolls up */}
                                {isUserScrolledUp && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            bottom: showInputBar ? '80px' : '20px',
                                            right: '20px',
                                            zIndex: 1000,
                                        }}
                                    >
                                        <IconButton
                                            onClick={scrollToBottom}
                                            sx={{
                                                bgcolor: '#25d366',
                                                color: '#ffffff',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                                '&:hover': {
                                                    bgcolor: '#128c7e',
                                                },
                                                width: '48px',
                                                height: '48px',
                                            }}
                                            title="Ir para o final da conversa"
                                        >
                                            <ArrowDownwardIcon />
                                        </IconButton>
                                    </Box>
                                )}

                                {showInputBar && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            p: 2,
                                            bgcolor: '#f0f2f5',
                                            borderTop: '1px solid #e9edef',
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Digite sua mensagem..."
                                            value={newMessage}
                                            onChange={(e) => {
                                                setNewMessage(e.target.value);
                                                // Use debounced typing handler
                                                if (e.target.value.length > 0) {
                                                    handleTyping(true);
                                                } else {
                                                    handleTyping(false);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    // Stop typing indicator when message is sent
                                                    handleTyping(false);
                                                    handleSendMessage();
                                                    // Force scroll to bottom after sending (user action)
                                                    setIsUserScrolledUp(false);
                                                    setTimeout(() => scrollToBottom(), 100);
                                                }
                                            }}
                                            onBlur={() => {
                                                // Stop typing indicator when input loses focus
                                                handleTyping(false);
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '24px',
                                                    backgroundColor: '#ffffff',
                                                    '& fieldset': { borderColor: 'transparent' },
                                                    '&:hover fieldset': { borderColor: 'rgba(0,0,0,0.2)' },
                                                    '&.Mui-focused fieldset': { borderColor: '#00a884' },
                                                },
                                            }}
                                        />

                                        <IconButton onClick={handleConditionalFileUpload} sx={{ ml: 1 }}>
                                            <AttachFileIcon sx={{ color: '#54656f' }} />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => {
                                                handleTyping(false);
                                                handleSendMessage();
                                                // Force scroll to bottom after sending (user action)
                                                setIsUserScrolledUp(false);
                                                setTimeout(() => scrollToBottom(), 100);
                                            }}
                                            sx={{ ml: 1 }}
                                        >
                                            <SendIcon sx={{ color: '#54656f' }} />
                                        </IconButton>
                                    </Box>
                                )}
                            </>
                        ) : (
                            <WelcomeScreen>
                                <WelcomeIcon>
                                    <ChatIcon />
                                </WelcomeIcon>
                                <WelcomeTitle>ISA - Chatbot</WelcomeTitle>
                                <WelcomeSubtitle>
                                    Selecione uma sessão de chat para começar a conversar ou crie uma nova sessão usando
                                    o botão no painel lateral.
                                </WelcomeSubtitle>
                            </WelcomeScreen>
                        )}
                    </ChatPanel>
                </WhatsAppContainer>
            </Container>

            {/* Loan Data Modal */}
            {/* Loan Modal */}
            <ModalEmprestimoUpdateDadosCadastrais
                showLoanModal={showLoanModal}
                setShowLoanModal={setShowLoanModal}
                loanData={loanData}
                loadingLoanData={loadingLoanData}
                handleLoanFormSubmit={handleLoanFormSubmit}
            />

            {/* Add Message Modal */}
            <ModalAddMessage
                showModal={showAddMessageModal}
                setShowModal={setShowAddMessageModal}
                selectedSessionId={selectedSessionId}
                mudarStatusSessao={mudarStatusSessao}
                handleLinkCommunication={handleLinkCommunication}
                setOptions={setOptions}
                setShowOptions={setShowOptions}
                setShowInputBar={setShowInputBar}
                setMessages={setMessages}
                LogoImg={LogoImg}
            />

            {/* View Communication Modal */}
            <ModalViewCommunication
                showModal={showViewCommunicationModal}
                setShowModal={setShowViewCommunicationModal}
                viewCommunicationId={viewCommunicationId}
            />

            {/* Regional Select Modal */}
            <ModalRegionalSelect
                isOpen={showRegionalModal}
                onClose={closeRegionalModal}
                onSelect={handleRegionalSelection}
                fetchRegionalCommunication={fetchRegionalCommunication}
                title="Selecione a Regional"
            />

            {/* Posto Escala Modal */}
            <ModalPostoEscala
                open={showPostoEscalaModal}
                onClose={closePostoEscalaModal}
                onSubmit={async (data) => {
                    setAusenciaData((prev) => ({ ...prev, ...data }));
                    closePostoEscalaModal();
                    if (handleSelectOption) {
                        await handleSelectOption(
                            'ausencia_posto_escala_submited',
                            'Dados de Posto e Escala informados',
                            data
                        );
                    }
                }}
                profile={profile}
                tokenChat={tokenChat}
                activeAusenciaData={ausenciaData}
            />

            {/* Data e Hora Ausencia Modal */}
            <ModalDataHoraAusencia
                open={showDataHoraAusenciaModal}
                onClose={closeDataHoraAusenciaModal}
                activeAusenciaData={ausenciaData}
                onSubmit={async (data) => {
                    setAusenciaData((prev) => ({ ...prev, ...data }));
                    closeDataHoraAusenciaModal();
                    if (handleSelectOption) {
                        await handleSelectOption(
                            'ausencia_data_hora_submited',
                            'Data e Hora informadas',
                            data
                        );
                    }
                }}
            />

            {/* Video Aula Modal */}
            {videoModal.open && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                    }}
                    onClick={() => setVideoModal({ open: false, url: '' })}
                >
                    <div
                        style={{
                            backgroundColor: '#000',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            width: '90%',
                            maxWidth: '900px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
                            position: 'relative',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 16px',
                                backgroundColor: '#1a1a1a',
                            }}
                        >
                            <Typography style={{ color: '#fff', fontWeight: 'bold', fontSize: '1rem' }}>
                                ▶ Vídeo Aula
                            </Typography>
                            <button
                                onClick={() => setVideoModal({ open: false, url: '' })}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '1.5rem',
                                    cursor: 'pointer',
                                    lineHeight: 1,
                                    padding: '0 4px',
                                }}
                                title="Fechar"
                            >
                                ×
                            </button>
                        </div>
                        <video
                            src={videoModal.url}
                            controls
                            autoPlay
                            style={{ width: '100%', display: 'block', maxHeight: '70vh' }}
                        />
                    </div>
                </div>
            )}

            {/* Date Picker Modal */}
            {showDatePickerModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                    }}
                    onClick={closeDatePickerModal}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            padding: '24px',
                            borderRadius: '8px',
                            maxWidth: '400px',
                            width: '90%',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Typography variant="h6" style={{ marginBottom: '16px' }}>
                            {datePickerTitle}
                        </Typography>
                        <div style={{ marginBottom: '16px' }}>
                            <Typography variant="body2" style={{ marginBottom: '8px', color: '#666' }}>
                                Escolha ou digite a data no calendário:
                            </Typography>
                            <input
                                type="date"
                                min="1900-01-01"
                                max="2100-12-31"
                                value={tempDateValue || (selectedDate ? selectedDate.toISOString().split('T')[0] : '')}
                                onClick={(e) => e.stopPropagation()}
                                onFocus={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                                onKeyUp={(e) => e.stopPropagation()}
                                onInput={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    // Store the value in local state without calling handleDateSelection
                                    setTempDateValue(e.target.value);
                                }}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                }}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                            <button
                                onClick={closeDatePickerModal}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#f5f5f5',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const dateValue =
                                        tempDateValue || (selectedDate ? selectedDate.toISOString().split('T')[0] : '');
                                    if (dateValue && dateValue.length === 10 && dateValue.includes('-')) {
                                        const parts = dateValue.split('-');
                                        if (parts.length === 3) {
                                            const year = parseInt(parts[0], 10);
                                            const month = parseInt(parts[1], 10);
                                            const day = parseInt(parts[2], 10);

                                            if (
                                                !isNaN(year) &&
                                                !isNaN(month) &&
                                                !isNaN(day) &&
                                                year >= 1900 &&
                                                year <= 2100 &&
                                                month >= 1 &&
                                                month <= 12 &&
                                                day >= 1 &&
                                                day <= 31
                                            ) {
                                                const date = new Date(year, month - 1, day, 12, 0, 0);
                                                if (!isNaN(date.getTime())) {
                                                    setTempDateValue('');
                                                    handleDateSelection(date);
                                                }
                                            }
                                        }
                                    }
                                }}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#0056b3',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Main>
    );
};

export default ChatbotWeb;
